












































































import {
  defineComponent,
  useContext,
  useRoute,
  ref,
  useFetch,
  computed,
  useMeta,
} from '@nuxtjs/composition-api'
import { useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useBreadcrumbsSchemaScript } from '~/composables/useSchemaScript'
import { encodeName } from '~/lib/utilities'
import { NewsItem } from '~/types/blog'

export default defineComponent({
  name: 'PagesBlogDetail',

  setup() {
    const { $api, i18n } = useContext()
    const route = useRoute()
    const newsItemsName = computed(() => route.value?.params.slug)
    const articleNews = ref<NewsItem | null>(null)
    useFetch(async () => {
      articleNews.value = await $api.blog.getNewsItemByName(newsItemsName.value)
    })

    const getUrl = (url: string) => {
      return encodeName(url) as string
    }
    const useBlocks = computed(() => articleNews.value?.useBlocks)
    const blocks = computed(() => articleNews.value?.blocks)
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    const {
      breadcrumbsSchemaScript,
      setBreadcrumbsSchemaScript,
    } = useBreadcrumbsSchemaScript()

    setBreadcrumbs([
      {
        label: i18n.t('title.news') as string,
        to: {
          name: 'blog-category',
        },
      },
      {
        label: newsItemsName.value,
      },
    ])
    setBreadcrumbsSchemaScript(breadcrumbs.value!)

    useMeta(() => {
      return breadcrumbsSchemaScript.value
        ? {
            script: [breadcrumbsSchemaScript.value],
          }
        : {}
    })

    return {
      useBlocks,
      articleNews,
      getUrl,
      blocks
    }
  },

  head: {},
})
